import type { DismissalRecord } from '@Application/ApplicationSettings/InstallPrompt/shouldOfferInstallPrompt';

export type InstallPromptDismissedPayload = DismissalRecord;

export type InstallPromptDismissedAction = {
	type: 'INSTALL_PROMPT_DISMISSED';
	payload: InstallPromptDismissedPayload;
};

export default (payload: InstallPromptDismissedPayload): InstallPromptDismissedAction => ({
	type: 'INSTALL_PROMPT_DISMISSED',
	payload,
});
